import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";

import { UrlConstantes } from "../utilerias/constantes/urlconstantes";
import {
  MonitoreoIA,
  MonitoreoIAReq,
  MonitoreoIARes,
} from "../shared/model/iso42001/monitoreo-ia.model";

/** Monitoreo continuo de sistemas de IA (ISO/IEC 42001). */
@Injectable({
  providedIn: "root",
})
export class MonitoreoIAService {
  constructor(private http: HttpClient) {}

  /**
   * Carga inicial: el activo evaluado, sus evaluaciones previas y la plantilla
   * de aspectos, en una sola llamada.
   */
  consultar(idInventarioIa: number): Observable<MonitoreoIARes> {
    const req: MonitoreoIAReq = { idInventarioIa };
    return this.http.post<MonitoreoIARes>(
      UrlConstantes.ISO42001_MONITOREO_CONSULTAR,
      req,
    );
  }

  obtener(idMonitoreoIa: number): Observable<MonitoreoIARes> {
    const req: MonitoreoIAReq = { idMonitoreoIa };
    return this.http.post<MonitoreoIARes>(
      UrlConstantes.ISO42001_MONITOREO_OBTENER,
      req,
    );
  }

  guardar(monitoreo: MonitoreoIA): Observable<MonitoreoIARes> {
    const req: MonitoreoIAReq = { monitoreo };
    return this.http.post<MonitoreoIARes>(
      UrlConstantes.ISO42001_MONITOREO_GUARDAR,
      req,
    );
  }

  actualizar(monitoreo: MonitoreoIA): Observable<MonitoreoIARes> {
    const req: MonitoreoIAReq = { monitoreo };
    return this.http.post<MonitoreoIARes>(
      UrlConstantes.ISO42001_MONITOREO_ACTUALIZAR,
      req,
    );
  }

  /** Borrado físico e irreversible de la evaluación y sus aspectos. */
  eliminar(idMonitoreoIa: number): Observable<MonitoreoIARes> {
    const req: MonitoreoIAReq = { idMonitoreoIa };
    return this.http.post<MonitoreoIARes>(
      UrlConstantes.ISO42001_MONITOREO_ELIMINAR,
      req,
    );
  }
}
